import { createIcon } from '@chakra-ui/react';

export const MbeBox = createIcon({
  displayName: 'MbeBox',
  viewBox: '0 0 187 151',
  path: (
    <g fill="none" fillRule="evenodd">
      <path
        d="m168.45 35.618-.5-.502zM92.247 151l1.504-1.003L92.247 151zM94.001 149.746z"
        fill="#231F20"
      />
      <path
        d="m95.411 75.066 16.774 16.749 51.178-25.74.13 44.89-67.878 34.139-.204-70.038zm-1.802-6.326-.006.003-67.528-33.47 67.34-31.337.194.089 67.325 30.856-67.325 33.86zM23.96 111.372l-.13-44.945 51.21 25.382 16.793-16.767.094 32.261.11 37.811-68.077-33.742zM6.05 53.627l16.256-16.233 68.277 33.841-16.255 16.232L6.05 53.627zm174.921-.407-68.086 34.242-16.261-16.237 40.616-20.428 27.47-13.814L180.97 53.22zm-13.893 59.943-.143-48.884L187 54.19l-18.65-18.623-.276-.276.276.276-.264-.335a8.31 8.31 0 0 0-3.062-2.407L93.402 0 21.974 33.24a8.05 8.05 0 0 0-3.024 2.443l-.026.034L0 54.616 20.246 64.65l.144 48.94L88.7 147.449l5.14 2.548-18.628-9.233 18.628 9.233 1.786-.899 71.451-35.935z"
        fill="#221E1F"
      />
    </g>
  ),
});
